// ABOUTME: Expand/Collapse all buttons component for accordions and grouped lists.
// ABOUTME: Provides consistent UI for expanding and collapsing all items in a group.

import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { ChevronsExpandIcon, ChevronsCollapseIcon } from "@shared/icons"

interface CExpandCollapseButtonsProps {
  onExpandAll: () => void
  onCollapseAll: () => void
  allExpanded?: boolean
  allCollapsed?: boolean
  size?: number
  className?: string
}

export const CExpandCollapseButtons: FC<CExpandCollapseButtonsProps> = ({
  onExpandAll,
  onCollapseAll,
  allExpanded = false,
  allCollapsed = false,
  size = 14,
  className = "",
}) => {
  const { t } = useTranslation()

  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      <button
        type="button"
        onClick={onExpandAll}
        disabled={allExpanded}
        className={`p-1 rounded hover:bg-gray-100 transition-colors ${allExpanded ? "opacity-30 cursor-default" : "cursor-pointer"}`}
        title={t("common.expandAll") || "Expand all"}
      >
        <ChevronsExpandIcon
          size={size}
          className="text-gray-500"
        />
      </button>
      <button
        type="button"
        onClick={onCollapseAll}
        disabled={allCollapsed}
        className={`p-1 rounded hover:bg-gray-100 transition-colors ${allCollapsed ? "opacity-30 cursor-default" : "cursor-pointer"}`}
        title={t("common.collapseAll") || "Collapse all"}
      >
        <ChevronsCollapseIcon
          size={size}
          className="text-gray-500"
        />
      </button>
    </div>
  )
}
